<div *ngIf="isGettingAccessToken; else errorConnection">
  <app-splash-screen></app-splash-screen>
</div>

<ng-template #errorConnection>
  <app-splash-screen [hasConnectionError]="true" (onClickRelogin)="relogin()"></app-splash-screen>
</ng-template>
